import React from "react";
import { chakra, forwardRef } from "@chakra-ui/react";
import { createElement } from "@wordpress/element";

export const Icon = () => {
	const Icon = createElement(
		"svg",
		{ width: 24, height: 24, viewBox: "0 0 32 32" },
		createElement("path", {
			fill: "currentColor",
			d: "M27.58 4a27.9 27.9 0 0 0-5.17 4 27 27 0 0 0-4.09 5.08 33.06 33.06 0 0 1 2 4.65A23.78 23.78 0 0 1 24 12.15V18a8 8 0 0 1-5.89 7.72l-.21.05a27 27 0 0 0-1.9-8.16A27.9 27.9 0 0 0 9.59 8a27.9 27.9 0 0 0-5.17-4L4 3.77V18a12 12 0 0 0 9.93 11.82h.14a11.72 11.72 0 0 0 3.86 0h.14A12 12 0 0 0 28 18V3.77zM8 18v-5.85a23.86 23.86 0 0 1 5.89 13.57A8 8 0 0 1 8 18zm8-16a3 3 0 1 0 3 3 3 3 0 0 0-3-3z",
		}),
	);
	return Icon;
};

export const RegistrationForm = (props) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="#475BB2"
		h="6"
		w="6"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M9.455 2a1.818 1.818 0 0 0-1.819 1.818h-.909A2.727 2.727 0 0 0 4 6.545v12.728A2.727 2.727 0 0 0 6.727 22h10.91a2.727 2.727 0 0 0 2.727-2.727V6.545a2.727 2.727 0 0 0-2.728-2.727h-.909A1.818 1.818 0 0 0 14.91 2H9.455Zm7.272 3.636a1.818 1.818 0 0 1-1.818 1.819H9.455a1.818 1.818 0 0 1-1.819-1.819h-.909a.91.91 0 0 0-.909.91v12.727a.91.91 0 0 0 .91.909h10.908a.91.91 0 0 0 .91-.91V6.546a.91.91 0 0 0-.91-.909h-.909Zm-7.272-.909v.91h5.454v-1.82H9.455v.91Zm-1.819 6.364a.91.91 0 0 1 .91-.91h7.272a.91.91 0 1 1 0 1.819H8.545a.91.91 0 0 1-.909-.91Zm.91 3.636a.91.91 0 1 0 0 1.819h7.272a.91.91 0 0 0 0-1.819H8.545Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
);

export const LoginForm = (props) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="#475BB2"
		h="6"
		w="6"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M8.545 9.273a.91.91 0 1 0 0 1.818h7.273a.91.91 0 1 0 0-1.818H8.545Zm-.909 4.545a.91.91 0 0 1 .91-.909h7.272a.91.91 0 1 1 0 1.818H8.545a.91.91 0 0 1-.909-.909Zm.909 2.728a.91.91 0 1 0 0 1.818h1.819a.91.91 0 1 0 0-1.819H8.545Z"
			clipRule="evenodd"
		></path>
		<path
			fillRule="evenodd"
			d="M7.636 3.818C7.636 2.814 8.45 2 9.455 2h5.454c1.004 0 1.818.814 1.818 1.818h.91a2.727 2.727 0 0 1 2.727 2.727v12.728A2.727 2.727 0 0 1 17.636 22H6.727A2.727 2.727 0 0 1 4 19.273V6.545a2.727 2.727 0 0 1 2.727-2.727h.91Zm7.273 3.637a1.818 1.818 0 0 0 1.818-1.819h.91a.91.91 0 0 1 .909.91v12.727a.91.91 0 0 1-.91.909H6.727a.91.91 0 0 1-.909-.91V6.546a.91.91 0 0 1 .91-.909h.908c0 1.005.814 1.819 1.819 1.819h5.454ZM9.455 5.636V3.818h5.454v1.818H9.455Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
);

export const Myaccount = (props) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="#475BB2"
		h="6"
		w="6"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-.072a6.999 6.999 0 0 0-3.678-5.2 5 5 0 1 0-6.5 0A6.997 6.997 0 0 0 5.072 20H5a1 1 0 0 1-1-1V5Zm2 17H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H6Zm10.899-2H7.101a5 5 0 0 1 9.798 0ZM12 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
);

export const EditProfile = (props) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="#475BB2"
		h="6"
		w="6"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M10.295 3.843a3.687 3.687 0 1 0 0 7.374 3.687 3.687 0 0 0 0-7.374ZM4.765 7.53a5.53 5.53 0 1 1 8.618 4.588.922.922 0 0 1-1.125 1.247 6.452 6.452 0 0 0-8.415 6.146.922.922 0 0 1-1.843 0 8.295 8.295 0 0 1 4.94-7.585A5.521 5.521 0 0 1 4.764 7.53Zm11.06 9.216a1.843 1.843 0 1 1 3.687 0 1.843 1.843 0 0 1-3.687 0Zm-1.812-.482a3.716 3.716 0 0 0 0 .965l-.13.057a.922.922 0 0 0 .75 1.685l.071-.032c.218.294.478.554.772.772l-.033.072a.922.922 0 1 0 1.685.749l.058-.13a3.712 3.712 0 0 0 .965 0l.058.13a.922.922 0 0 0 1.684-.749l-.032-.073c.293-.217.554-.477.771-.771l.072.032a.922.922 0 0 0 .748-1.685l-.129-.057a3.73 3.73 0 0 0 0-.965l.13-.058a.922.922 0 1 0-.75-1.684l-.071.032a3.708 3.708 0 0 0-.77-.771l.031-.072a.922.922 0 0 0-1.684-.748l-.058.128a3.72 3.72 0 0 0-.966 0l-.057-.128a.922.922 0 1 0-1.684.748l.031.072a3.707 3.707 0 0 0-.77.77l-.073-.031a.922.922 0 0 0-.748 1.684l.129.058Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
);
export const EditPassword = (props) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="#475BB2"
		h="6"
		w="6"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M5.636 4a.91.91 0 0 0 0 1.818h.91a1.818 1.818 0 0 1 1.818 1.818v3.527a.993.993 0 0 0-.367.237l-.384.383-.383-.383c-.289-.29-.681-.365-.877-.17-.195.196-.12.588.17.877l.383.383-.383.384c-.29.288-.365.68-.17.876.196.195.588.12.877-.169l.383-.384.384.384c.112.112.24.193.367.237v2.91a1.818 1.818 0 0 1-1.819 1.817h-.909a.91.91 0 1 0 0 1.819h.91a3.637 3.637 0 0 0 2.727-1.232A3.637 3.637 0 0 0 12 20.364h.91a.91.91 0 1 0 0-1.817H12a1.818 1.818 0 0 1-1.818-1.819v-9.09A1.818 1.818 0 0 1 12 5.817h.91a.91.91 0 1 0 0-1.818H12A3.637 3.637 0 0 0 9.273 5.23 3.635 3.635 0 0 0 6.545 4h-.909Zm2.728 8.534v-.087l-.044.043.044.043Zm-3.637-3.08a.91.91 0 0 0-.909.91V14a.91.91 0 0 0 .91.91h.908a.91.91 0 1 1 0 1.817h-.909A2.728 2.728 0 0 1 2 14v-3.636a2.727 2.727 0 0 1 2.727-2.728h.91a.91.91 0 0 1 0 1.819h-.91Zm8.182-1.818a.91.91 0 1 0 0 1.819h6.364a.91.91 0 0 1 .909.909V14a.91.91 0 0 1-.91.91H12.91a.91.91 0 1 0 0 1.817h6.364A2.728 2.728 0 0 0 22 14v-3.636a2.727 2.727 0 0 0-2.727-2.728h-6.364Zm.795 5.238-.384-.384.384-.383c.289-.289.364-.681.17-.877-.196-.195-.588-.119-.877.17l-.384.383-.383-.383c-.289-.29-.681-.365-.877-.17-.195.196-.12.588.17.877l.383.383-.383.384c-.29.288-.365.68-.17.876.196.195.588.12.877-.169l.383-.384.384.384c.288.289.68.364.876.169.195-.195.12-.588-.17-.876Zm3.13-1.475.383.384.384-.383c.289-.289.68-.365.876-.17.195.196.12.588-.169.877l-.384.383.384.384c.288.288.364.68.169.876-.195.195-.588.12-.876-.17l-.384-.383-.383.384c-.289.289-.681.364-.877.17-.195-.196-.12-.588.17-.877l.383-.384-.384-.383c-.288-.289-.364-.681-.169-.877.196-.195.588-.12.877.17Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
);
export const ViewProfileDetails = (props) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="#475BB2"
		h="6"
		w="6"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M14.911 8.874c0 .828-.31 1.583-.822 2.156a4.531 4.531 0 0 1 1.734 2.13 4.5 4.5 0 0 1 .314 1.736l-1.818-.032a2.704 2.704 0 0 0-2.523-2.747 2.703 2.703 0 0 0-2.523 2.747l-1.818.032a4.522 4.522 0 0 1 1.898-3.764 3.238 3.238 0 1 1 5.558-2.258Zm-4.657 0a1.42 1.42 0 1 1 1.44 1.42h-.02a1.42 1.42 0 0 1-1.42-1.42Z"
			clipRule="evenodd"
		></path>
		<path
			fillRule="evenodd"
			d="M9.273 16.546a.91.91 0 1 0 0 1.818h5.3a.91.91 0 1 0 0-1.819h-5.3Z"
			clipRule="evenodd"
		></path>
		<path
			fillRule="evenodd"
			d="M4.727 2A2.727 2.727 0 0 0 2 4.727v14.546A2.727 2.727 0 0 0 4.727 22h14.546A2.727 2.727 0 0 0 22 19.273V4.727A2.727 2.727 0 0 0 19.273 2H4.727Zm-.909 2.727a.91.91 0 0 1 .91-.909h14.545a.91.91 0 0 1 .909.91v14.545a.91.91 0 0 1-.91.909H4.728a.91.91 0 0 1-.909-.91V4.728Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
);
export const Popup = (props) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="#475BB2"
		h="6"
		w="6"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M7.2 13.8a.84.84 0 0 1 .84-.84h7.92a.84.84 0 0 1 0 1.68H8.04a.84.84 0 0 1-.84-.84Zm0 3.36a.84.84 0 0 1 .84-.84h7.92a.84.84 0 0 1 0 1.68H8.04a.84.84 0 0 1-.84-.84Zm10.685-7.111a.72.72 0 0 0 0-1.018l-.949-.95.949-.948a.72.72 0 1 0-1.018-1.018l-.95.949-.948-.95a.72.72 0 1 0-1.018 1.019l.949.949-.95.949a.72.72 0 1 0 1.019 1.018l.949-.949.949.949a.72.72 0 0 0 1.018 0Z"
			clipRule="evenodd"
		></path>
		<path
			fillRule="evenodd"
			d="M1.92 4.8A2.88 2.88 0 0 1 4.8 1.92h14.4a2.88 2.88 0 0 1 2.88 2.88v14.4a2.88 2.88 0 0 1-2.88 2.88H4.8a2.88 2.88 0 0 1-2.88-2.88V4.8Zm2.88-.878h14.4c.485 0 .878.393.878.878v14.4a.878.878 0 0 1-.878.878H4.8a.878.878 0 0 1-.878-.878V4.8c0-.485.393-.878.878-.878Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
);
export const FrontendListing = (props) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="#475BB2"
		h="6"
		w="6"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M4 2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm0 2h5v5H4V4Zm0 9a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2H4Zm0 2h5v5H4v-5Z"
			clipRule="evenodd"
		></path>
		<path
			fillRule="evenodd"
			d="M13 4a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7Zm-1 7a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
);
export const DownloadPdfButton = (props) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="#475BB2"
		h="6"
		w="6"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M8.46 22H5.2a2.8 2.8 0 0 1-2.8-2.8V4.8A2.8 2.8 0 0 1 5.2 2h6.3a1 1 0 0 1 .7.29l6.3 6.3a1 1 0 0 1 .3.71v5.54a1 1 0 0 1-2 0V10.3h-5.3a1 1 0 0 1-1-1V4H5.2a.8.8 0 0 0-.8.8v14.4a.8.8 0 0 0 .8.8h3.26a1 1 0 0 1 0 2Zm4-13.7h2.89l-2.86-2.89-.03 2.89Zm.28 8.19a1.73 1.73 0 0 0-.74-.19h-1.9V22h.9v-2.2h1c.28.007.559-.055.81-.18.223-.12.407-.3.53-.52a1.65 1.65 0 0 0 .18-.79v-.47a1.73 1.73 0 0 0-.22-.84 1.26 1.26 0 0 0-.53-.51h-.03Zm-.2 1.75a.74.74 0 0 1-.17.5.54.54 0 0 1-.43.19H11v-1.77h1a.549.549 0 0 1 .44.19.78.78 0 0 1 .16.51l-.06.38Zm3.35-1.94h-1.63V22h1.65a2 2 0 0 0 .94-.19c.25-.12.456-.316.59-.56a1.87 1.87 0 0 0 .2-.88v-2.43a1.58 1.58 0 0 0-.45-1.21 1.81 1.81 0 0 0-1.27-.43h-.03Zm.81 4a.778.778 0 0 1-.22.58.81.81 0 0 1-.6.21h-.75v-4h.75a.81.81 0 0 1 .6.21.77.77 0 0 1 .22.58v2.42Zm2.7-3.18v1.63h1.86v.85h-1.83V22h-.9v-5.7h3.07v.86l-2.2-.04Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
);
export const ContentRestriction = (props) => (
	<chakra.svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="#475BB2"
		h="6"
		w="6"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M7.5 2c-.716 0-1.403.287-1.91.799a2.741 2.741 0 0 0-.79 1.928v.91c0 .501.403.908.9.908s.9-.407.9-.909v-.909c0-.24.095-.472.264-.643a.895.895 0 0 1 .636-.266h6.3v2.727c0 .724.284 1.417.79 1.929a2.686 2.686 0 0 0 1.91.799h2.7v10a.914.914 0 0 1-.264.643.896.896 0 0 1-.636.266H5.7c-.497 0-.9.407-.9.909s.403.909.9.909h12.6c.716 0 1.403-.287 1.91-.799.505-.511.79-1.205.79-1.928V7.455a.914.914 0 0 0-.264-.643l-4.5-4.546A.895.895 0 0 0 15.6 2H7.5Zm8.1 2.195v2.35c0 .242.095.473.264.643.168.17.397.267.636.267h2.327L15.6 4.195Z"
			clipRule="evenodd"
		></path>
		<path
			fillRule="evenodd"
			d="M3 13.818A1.81 1.81 0 0 1 4.8 12v-.91c0-.722.284-1.416.79-1.928a2.686 2.686 0 0 1 1.91-.798 2.69 2.69 0 0 1 1.91.798c.506.512.79 1.206.79 1.929V12c.994 0 1.8.814 1.8 1.818v2.728a1.81 1.81 0 0 1-1.8 1.818H4.8A1.81 1.81 0 0 1 3 16.545v-2.727ZM8.4 12v-.91a.914.914 0 0 0-.264-.642.895.895 0 0 0-1.272 0 .914.914 0 0 0-.264.643V12h1.8Zm1.8 1.818v2.728H4.8v-2.728h5.4Z"
			clipRule="evenodd"
		></path>
	</chakra.svg>
);
